import { useCanAdministerAIAgents } from "~/pages/manifold-nextgen/hooks/useCanAdministerAIAgents";
import { Agent } from "~/services/agents";

// Duplicating an agent maps to the `can_duplicate` grant, held at any access
// level (USER, EDITOR, or OWNER). A SYSTEM agent confers a USER-level grant on
// everyone via its `user:*` baseline, so any visible agent — SYSTEM or CUSTOMER —
// is duplicable. Distinct from deleting (`can_delete`), which only owners hold.
// An `admin:agents` caller can duplicate any visible agent via the FGA bypass,
// even one it holds no direct grant on (`access_level` null).
export const useCanDuplicateAgent = (agent: Agent | undefined): boolean => {
  const isAdmin = useCanAdministerAIAgents();
  return !!agent && (agent.access_level !== null || isAdmin);
};
